import request from '@/utils/request'

/**
 * 获取课程学情分析数据（老师端）
 * 返回每个学生的：
 * - 作业完成情况
 * - 讨论参与情况
 * - 综合表现
 */
export function getCourseAnalysis(courseId) {
  return request({
    url: `/amc/data-collection/course/${courseId}/summary`,
    method: 'get'
  }).then((res) => {
    try {
      const list = res && Array.isArray(res.data) ? res.data : []
      const totalStudents = list.length

      let totalHomeworkTotal = 0
      let totalHomeworkCompleted = 0
      list.forEach(s => {
        const hw = (s && s.homeworkData) ? s.homeworkData : {}
        const total = Number(hw.totalHomeworks || 0)
        const completed = Number(hw.completedHomeworks || 0)
        totalHomeworkTotal += total
        totalHomeworkCompleted += completed
      })
      const homeworkCompletionRate = totalHomeworkTotal > 0
        ? Math.round((totalHomeworkCompleted * 100) / totalHomeworkTotal)
        : 0

      return {
        ...res,
        data: {
          summary: {
            totalStudents,
            homeworkCompletionRate,
            discussionParticipationRate: 0
          },
          students: list
        }
      }
    } catch (e) {
      return res
    }
  })
}

/**
 * 获取单个学生的详细学情
 */
export function getStudentAnalysis(courseId, studentId) {
  return request({
    url: `/amc/data-collection/student/${studentId}/course/${courseId}`,
    method: 'get'
  })
}

/**
 * 获取班级学情统计
 */
export function getClassAnalysis(classId) {
  return request({
    url: `/amc/data-collection/course/${classId}/summary`,
    method: 'get'
  })
}
